// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
}

h4 {
  font-size: 1.1rem;
  font-weight: 700;
  color: #1a1a2e;
  margin-bottom: 16px;
}

.kb-article-row {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  border-radius: 6px;
  margin-bottom: 4px;
  cursor: pointer;
  transition: background 0.12s ease;
  border: 1px solid transparent;
}

.kb-article-row:hover {
  background: #f8f9fa;
  border-color: #e8eaed;
}

.kb-article-title {
  flex: 1;
  font-weight: 500;
  color: #1a1a2e;
  font-size: 0.92rem;
}

.kb-article-meta {
  display: flex;
  align-items: center;
  gap: 16px;
  font-size: 0.8rem;
  color: #6c757d;
}

.kb-article-meta .badge {
  font-size: 0.68rem;
  font-weight: 500;
  padding: 3px 8px;
  border-radius: 4px;
  background: #e8eaed;
  color: #495057;
}
`, "",{"version":3,"sources":["webpack://./src/app/knowledge-base-module/components/kb-article-list/kb-article-list.component.css"],"names":[],"mappings":"AAAA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,iCAAiC;EACjC,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB","sourcesContent":[":host {\n  display: block;\n}\n\nh4 {\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: #1a1a2e;\n  margin-bottom: 16px;\n}\n\n.kb-article-row {\n  display: flex;\n  align-items: center;\n  padding: 12px 16px;\n  border-radius: 6px;\n  margin-bottom: 4px;\n  cursor: pointer;\n  transition: background 0.12s ease;\n  border: 1px solid transparent;\n}\n\n.kb-article-row:hover {\n  background: #f8f9fa;\n  border-color: #e8eaed;\n}\n\n.kb-article-title {\n  flex: 1;\n  font-weight: 500;\n  color: #1a1a2e;\n  font-size: 0.92rem;\n}\n\n.kb-article-meta {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  font-size: 0.8rem;\n  color: #6c757d;\n}\n\n.kb-article-meta .badge {\n  font-size: 0.68rem;\n  font-weight: 500;\n  padding: 3px 8px;\n  border-radius: 4px;\n  background: #e8eaed;\n  color: #495057;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
